<template>
    <div>
        <form class="needs-validation" v-on:submit.prevent="createBuilding" novalidate>
            <div class="p-3">
                <h4><label for="view_latest_report" class="col-form-label d-block">Access code for view latest report</label></h4>
                <div class="form-row">
                    <div class="col-sm-2">
                        <button type="button" class="btn btn-danger" v-bind:disabled="!access_code.view_latest_report.form.code_exists" v-on:click="remove('view_latest_report')">Remove</button>
                    </div>
                    <div class="col-sm-5">
                        <input type="text" class="form-control" minlength="8" maxlength="16" id="view_latest_report" v-model="access_code.view_latest_report.data.access_code"
                               placeholder="8 - 16 characters"
                               v-bind:readonly="!access_code.view_latest_report.form.edit"
                               v-bind:disabled="!access_code.view_latest_report.form.edit">
                        <div class="invalid-feedback">
                            8 - 16 characters
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="view_latest_report_edit" v-model="access_code.view_latest_report.form.edit" v-on:click="access_code.view_latest_report.form.edit = !access_code.view_latest_report.form.edit">
                            <label class="form-check-label" for="view_latest_report_edit">
                                Edit
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <template v-if="access_code.view_latest_report.form.edit">
                            <button type="button" class="btn btn-primary btn-block" v-on:click="update('view_latest_report')">Update access code</button>
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-primary btn-block" v-on:click="populate('view_latest_report')">Generate new random code</button>
                        </template>
                    </div>
                </div>
                <div class="m-auto pt-3 qrcode-placeholder">
                    <div ref="view_latest_report_qrcode"></div>
                </div>
            </div>
        </form>
        <div class="form-row">
            <div class="col-md-12 mb-3">
                <transition name="fade">
                    <div class="alert alert-success" v-if="success">Updated successfully.</div>
                    <div class="alert alert-warning" v-if="failed">{{failed}}</div>
                </transition>
            </div>
        </div>
    </div>
</template>
<style scoped>
    input:invalid {
        border: 2px dashed red;
    }
    input:invalid + .invalid-feedback {
        display: block;
    }
    .qrcode-placeholder {
        width: 200px;
    }
</style>
<script>
  import QRCodeFn from '@/utils/qrcode.js';

  export default {
    components: {
    },
    data () {
      return {
        id: '',
        success: undefined,
        failed: undefined,
        access_code: {
          view_latest_report: {
            qrcode: undefined,
            data: {
              access_code: '',
              uri: undefined,
            },
            form: {
              edit: false,
              code_exists: false,
            }
          },
        },

      }
    },
    computed: {
      QRCode() {
        return QRCodeFn();
      }
    },
    mounted () {
      this.id = this.$route.params.buildingId;
      this.access_code.view_latest_report.qrcode = new this.QRCode(this.$refs['view_latest_report_qrcode'], {
        width: 200,
        height: 200,
        correctLevel : this.QRCode.CorrectLevel.M
      });
      this.load('view_latest_report');
    },
    methods: {
      loadApi: function(field, method) {
        return {
          view_latest_report: {
            get: () => {
              return {
                method: 'GET',
                path: `api/building-access-code/${this.id}/report`,
                path_template: '/api/building-access-code/{building_id}/report'
                }
            },
            post: () => {
              return {
                method: 'POST',
                path: `api/building-access-code/${this.id}/report`,
                path_template: '/api/building-access-code/{building_id}/report'
              }
            },
            patch: () => {
              return {
                method: 'PATCH',
                path: `api/building-access-code/${this.id}/report`,
                path_template: '/api/building-access-code/{building_id}/report',
                data: {
                  access_code: this.access_code.view_latest_report.data.access_code
                }
              }
            },
            delete: () => {
              return {
                method: 'DELETE',
                path: `api/building-access-code/${this.id}/report`,
                path_template: '/api/building-access-code/{building_id}/report',
              }
            },
          }
        }[field][method]();
      },
      setData: function(response, field) {
        let top = this;
        switch (response.status) {
          case 200:
            this.access_code[field].data = response.data.data;
            this.access_code[field].form.code_exists = true;
            this.access_code.view_latest_report.form.edit = false;
            this.access_code[field].qrcode.makeCode(this.access_code[field].data.uri);
            break;
          case 410:
            this.access_code[field].data.access_code = '';
            this.access_code[field].data.uri = '';
            this.access_code[field].form.code_exists = false;
            break;
          case 422:
            this.failed = response.data.message;
            setTimeout(function() { top.failed = undefined; }, 1000);
            break;
        }

        return response;
      },
      load: function(field) {
        this.$store.dispatch('apiResult', this.loadApi(field, 'get'))
          .then(response => {
            return this.setData(response, field);
          });
      },
      update: function(field) {
        let top = this;
        this.$store.dispatch('apiResult', this.loadApi(field, 'patch'))
          .then(response => {
            return this.setData(response, field);
          })
          .then(response => {
            switch (response.status) {
              case 200:
                this.success = true;
                setTimeout(function () {
                  top.success = undefined;
                }, 1000);
                break;
            }
          });
      },
      populate: function(field) {
        this.$store.dispatch('apiResult', this.loadApi(field, 'post'))
          .then(response => {
            return this.setData(response, field);
          });
      },
      remove: function(field) {
        let top = this;
        this.$store.dispatch('apiResult', this.loadApi(field, 'delete'))
          .then(response => {
            this.access_code[field].data.access_code = '';
            this.access_code[field].data.uri = '';
            this.access_code[field].form.code_exists = false;
            this.success = true;
            setTimeout(function() { top.success = undefined; }, 1000);
          });
      },
    }
  }
</script>